import { useAgentContext } from '@Providers';

import { GuidedJourney } from '@Models';
import JourneyCard from './JourneyCard';
import JourneyCardSkeleton from './JourneyCardSkeleton';

interface JourneyGridProps {
  journeys: GuidedJourney[];
  isLoading?: boolean;
  onSelect?: (journey: GuidedJourney) => void;
}

const SKELETON_COUNT = 3;

const JourneyGrid = ({ journeys, isLoading = false, onSelect }: JourneyGridProps) => {
  const { mode } = useAgentContext();
  const isFullscreen = mode === 'fullscreen';
  const isCompact = !isFullscreen;
  const gridCols = isFullscreen ? 'grid-cols-1 sm:grid-cols-2' : 'grid-cols-1';
  const gridStyle = isFullscreen ? { gridAutoRows: 'minmax(108px, auto)' } : undefined;

  if (isLoading && journeys.length === 0) {
    return (
      <div className={`grid w-full gap-2.5 ${gridCols}`} style={gridStyle}>
        {Array.from({ length: SKELETON_COUNT }).map((_, idx) => {
          const isOddLast = isFullscreen && idx === SKELETON_COUNT - 1 && SKELETON_COUNT % 2 === 1;
          return (
            <JourneyCardSkeleton
              // eslint-disable-next-line react/no-array-index-key
              key={`journey-skel-${idx}`}
              compact={isCompact}
              fullWidth={isOddLast}
            />
          );
        })}
      </div>
    );
  }

  if (journeys.length === 0) return null;

  return (
    <div className={`grid w-full gap-2.5 ${gridCols}`} style={gridStyle}>
      {journeys.map((journey, index) => {
        const isOddLast = isFullscreen && index === journeys.length - 1 && journeys.length % 2 === 1;
        return (
          <JourneyCard
            key={journey.id ?? journey.display ?? index}
            journey={journey}
            index={index}
            fullWidth={isOddLast}
            compact={isCompact}
            onClick={onSelect}
          />
        );
      })}
    </div>
  );
};

export default JourneyGrid;
